'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import AddressIcon from '../../components/Common/AddressIcon';
import { ImageWithFallback } from '../../components/Common/ImageWithFallback';
import WalletIcon from '../../components/Icons/WalletIcon';
/**
 * Renders a wallet's icon. After the contract migration to `Wallet.icon: string`,
 * use this component everywhere instead of `<wallet.icon />`. Falls back to a
 * generative AddressIcon when the wallet didn't ship an icon URL.
 */
const WalletIconView = ({ wallet, className, size = 24 }) => {
    if (wallet.icon) {
        return (_jsx(ImageWithFallback, { src: wallet.icon, alt: wallet.displayName ?? wallet.id, width: size, height: size, className: className }));
    }
    if (wallet.address) {
        return _jsx(AddressIcon, { address: wallet.address, size: size, className: className });
    }
    return _jsx(WalletIcon, { className: className });
};
export default WalletIconView;
